import { useEffect, useState } from "react";
import AppConfig from './AppConfig.json'
import axios from "axios";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router";
import * as actions from './actions'
import InterestList from './interest.json'
import 'react-phone-input-2/lib/style.css'
import ErrorMessage from "./ErrorMessage";


export function MemberEditInterest({ app, onUpdate }) {
    const { currentUserProfile } = app
    const history = useHistory()
    const [interest, setInterest] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        let interests = currentUserProfile.style.map(s => {
            let item = InterestList.filter(l => l[0] === s.lifeStyleType)
            return item.length > 0 ? item[0][0] : currentUserProfile.style
        })
        console.log(interests)
        setInterest(interests)
    }, [])


    const formValidate = () => {
        // const re = /0[0-9]{9}/;
        // console.log(mobileNumber, re.test(mobileNumber))

        return true //mobileNumber && re.test(mobileNumber)
    }

    const sendUpdate = async () => {

        let body = {
            lifeStyle: interest.map(x => (
                {
                    "lifeStyleType": x,
                    "lifeStyleValue": x,
                    "activeFlag": "Y"
                }))
        }

        let result = await axios.post(`${AppConfig.endpoint}/member/update/interest`, body, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        if (result.data.success) {
            history.push("/member/profile")
            onUpdate && onUpdate()
        }
        else {
            setErrorMessage(result.data)
        }
    }

    const isSelected = (item) => {
        console.log(item)
        return interest.includes(item)
    }

    return <div className="edit-screen pin-auth-screen">
        {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
        <div class="section-header">Interests</div>
        <div className="edit-form">
            <div className="instruction">Let us know you more to deliver you the best experience. Select what you are interested in.</div>
            <br />

            {InterestList.map(i =>
                <div className={`interest-item ${isSelected(i[0]) ? 'selected' : ''}`} onClick={() => {
                    if (isSelected(i[0])) {
                        setInterest(interest.filter(x => x !== i[0]))
                    }
                    else {
                        interest.push(i[0])
                        setInterest([...interest])
                        console.log(interest)
                    }
                }}>{i[1]}</div>
            )}


            <div className="screen-footer">
                <button className="button is-fullwidth is-save" disabled={!formValidate()} onClick={() => sendUpdate()}>Continue</button>
            </div>
        </div>
    </div>
}

export default withRouter(connect((state) => state, actions)(MemberEditInterest))